import React from 'react';
import {
  useFormContext,
  RegisterOptions,
} from 'react-hook-form/dist/index.ie11';
import { CookbookServerSelectSearchWrapper } from 'src/components/CookbookServerSelectSearchWrapper/CookbookServerSelectSearchWrapper';
import { useLocationsSelectSearchControl } from 'src/components/common/LocationsSelectSearchControl/hooks/useLocationsSelectSearchControl';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface LocationsSelectSearchControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function LocationsSelectSearchControl({
  name,
  id,
  rules = {},
}: LocationsSelectSearchControlProps): JSX.Element {
  const { control, errors } = useFormContext();
  const { options, handleSearchChange, isLoadingFetchedLocation } =
    useLocationsSelectSearchControl({
      name,
    });

  return (
    <CookbookServerSelectSearchWrapper
      name={name}
      id={id}
      blockWidth
      control={control}
      error={errors[name]}
      label={addAsterisk('Location', rules)}
      placeholder={isLoadingFetchedLocation ? 'loading...' : 'Select location'}
      options={options}
      fetchOptions={handleSearchChange}
      rules={rules}
    />
  );
}
